import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Schedule from "@material-ui/icons/Schedule";
import Info from "@material-ui/icons/Info";
import LocationOn from "@material-ui/icons/LocationOn";
import Gavel from "@material-ui/icons/Gavel";
import HelpOutline from "@material-ui/icons/HelpOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Accordion from "components/Accordion/Accordion.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import DataSource from "assets/img/resources/Data_source.png";
import FS from "assets/img/resources/Field_Glossary.png";
import Rules from "assets/img/resources/Rules.png";
import DataProcessing from "assets/img/resources/Data_Processing.png";
import DataModel from "assets/img/resources/cmp_data_model.png";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
const styles = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center"
  },
  cardCategory: {
    margin: "0",
    color: "#999999"
  }
};

class DataSources extends React.Component {
        render() {
          let image = ''
          let pathname = window.location.pathname
          if (pathname.indexOf('resources/datasources') != -1) {
            image = DataSource
          } else if (pathname.indexOf('resources/datamodel') != -1) {
            image = DataModel
          } else if (pathname.indexOf('resources/rules') != -1) {
            image = Rules
          } else if (pathname.indexOf('resources/glossary') != -1) {
            image = FS
          } else if (pathname.indexOf('resources/dataprocessing') != -1) {
            image = DataProcessing
          }
          return(
              <img src={image} alt="..." style={{paddingTop:"35px"}} />
          )
        }
    }

export default (DataSources);


// WEBPACK FOOTER //
// ./src/views/Resources/DataSources.jsx